import React, { useState, useRef, useEffect } from 'react'
import styles from './Description.module.scss'
import { ReactComponent as ArrowDown } from '../../../assets/svgs/arrow_down.svg'

const Description = (props) => {

	const [descriptionStatus, setDescriptionStatus] = useState(false)

	const descriptionStyles = [styles.Description]
	if (descriptionStatus) {
		descriptionStyles.push(styles.ActiveDescription)
	}
	const arrowStyles = [styles.Arrow]
	if (descriptionStatus) {
		arrowStyles.push(styles.ActiveArrow)
	}

	const [height, setHeight] = useState(0)
	const ref = useRef(null)

	useEffect(() => {
		if (ref.current) {
			setHeight(ref.current.clientHeight)
		}

	})


	return (
		<div>
			{
				props.description && (
					<>
						<div ref={ref}>
							<p className={descriptionStyles.join(' ')}>{props.description}</p>
						</div>

						{height > 36 ? <div className={arrowStyles.join(' ')}>
							<ArrowDown with={24} height={24} fill={'#B4B9C9'} onClick={(e) => {
								e.preventDefault()
								e.stopPropagation()
								setDescriptionStatus((descriptionStatus) => (!descriptionStatus))
							}}/>
						</div> : ''}
					</>
				)
			}
		</div>
	)
}

export default Description
